import { useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';
import '../../css/base.css';
import LocalWalks from './localWalks';
import Walks from './walks';
import Mountains from './mountains';
import OnTheWater from './onTheWater';
import DayTrips from './dayTrips';
import WalkBraeDetails from './walkBraeDetails';
import WalkDryIslandDetails from './walkDryIslandDetails';
import WalkCorranDetails from './walkCorranDetails';
import BeinnSgritheallDetails from './beinnSgritheallDetails';
import WalkSandaigDetails from './walkSandaigDetails';
import WalkLochansDetails from './walkLochansDetails';
import WalkCorranCoastalDetails from './walkCorranCoastalDetails';
import { setSection } from '../../store/AppSlice';
import larvenView_large from '../../img/larvenView_large.jpg';
import larvenView_medium from '../../img/larvenView_medium.jpg';
import larvenView_small from '../../img/larvenView_small.jpg';


const Activities = () => {
  const dispatch = useDispatch();
  const appstate = useSelector((state) => state.appState);

  useEffect(() => {
    var initialMenu = document.getElementById("activities-local-walks-menu-item");
    if (initialMenu) {
      initialMenu.style.backgroundColor = "#468faf";
      initialMenu.style.color = "#325288";  
    }
  }, []);


  const selectSection = (event, data) => {

    var allMenuItems = document.getElementsByClassName("left-menu-btn");

    Array.from(allMenuItems).forEach((item) => {
      item.style.backgroundColor = "#61a5c2";
      item.style.color = "white";
    });      

    var menu = document.getElementById(event.target.id);
    menu.style.backgroundColor = "#468faf";
    menu.style.color = "#325288";

    dispatch(setSection(data));
  }
  let sectionName = <div>Default</div>;
  let mountainPhoto = null;
  let activitySelected = "";

  switch (appstate.section) {
    case "LOCAL_WALKS":
      sectionName =  <LocalWalks />;
      break;
    case "WALKS":
      sectionName =  <Walks />;
      break;
    case "MOUNTAINS":
      sectionName =  <Mountains />;
      mountainPhoto = <div className="row">
                        <div className="col-12 imagesBackgroundColour">
                          <picture>
                            <source srcSet={`${larvenView_small} 1x,${larvenView_medium} 2x`} media="(max-width: 600px)" />
                            <img srcSet={`${larvenView_medium} 1x,${larvenView_large} 2x`}
                                src={larvenView_medium} alt="Larven View" className="image"
                            />
                          </picture>
                        </div>
                      </div>;
      break;
    case "ON_THE_WATER":
      sectionName =  <OnTheWater />;
      break;
    case "DAY_TRIPS":
      sectionName =   <DayTrips />;
      break;
    default:
      sectionName = <LocalWalks />; 
  }

  switch (appstate.activity) {
    case "BRAE":
      activitySelected =  <WalkBraeDetails />;
      break;
    case "DRY_ISLAND":
      activitySelected =  <WalkDryIslandDetails />;
      break;
    case "CORRAN":
      activitySelected =  <WalkCorranDetails />;
      break;
    case "BEINN_SGRITHEALL":
      activitySelected =  <BeinnSgritheallDetails />;
      break;
    case "SANDAIG":
      activitySelected =  <WalkSandaigDetails />;
      break;
    case "LOCHANS":
      activitySelected =  <WalkLochansDetails />;
      break;
    case "CORRAN_COASTAL":
      activitySelected =  <WalkCorranCoastalDetails />;
      break;
    default:
      activitySelected = ""; 

  }

  if (activitySelected === "") {
    return (
      <div>
        <div className="row imagesBackgroundColour your-stay-condensed">
          <div className="col-3 col-md-2 col-xl-1 left-menu-col">
            <div id="activities-local-walks-menu-item" className="left-menu-btn" onClick={(event) => selectSection(event, "LOCAL_WALKS")}>
                Short Walks
            </div>
            <div id="activities-walks-menu-item" className="left-menu-btn" onClick={(event) => selectSection(event, "WALKS")}>
                Walks
            </div>
            <div id="activities-mountains-menu-item" className="left-menu-btn" onClick={(event) => selectSection(event, "MOUNTAINS")}>
                Mountains
            </div>
            <div id="activities-kayaks-menu-item" className="left-menu-btn" onClick={(event) => selectSection(event, "ON_THE_WATER")}>
                Sea Loch
            </div>
            <div id="activities-day-trips-menu-item" className="left-menu-btn" onClick={(event) => selectSection(event, "DAY_TRIPS")}>
                Day Trips
            </div>
          </div>
          <div className="col-9 col-md-10 col-xl-11 imagesBackgroundColour">
            <div className="generalText">
              <div className="generalTextBox">
                {sectionName}
              </div>
            </div>
          </div>
        </div>
        <div>
          {mountainPhoto}
        </div>
      </div>
    );  
  } else {
    return activitySelected;
  }
    
}

export default Activities
